import * as React from 'react';

export const SvgGoogle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 19 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M.643 0h18v18h-18z" />
      <path
        fill="#4285F4"
        d="M18.283 9.238c0-.638-.057-1.252-.164-1.84H9.643v3.48h4.843a4.14 4.14 0 01-1.795 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      />
      <path
        fill="#34A853"
        d="M9.686 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.259c-.806.54-1.837.86-3.047.86-2.345 0-4.329-1.584-5.036-3.711H1.643v2.332A8.997 8.997 0 009.686 18z"
      />
      <path
        fill="#FBBC05"
        d="M4.607 10.752a5.41 5.41 0 01-.282-1.71c0-.593.102-1.17.282-1.71V5H1.6a8.996 8.996 0 00-.957 4.042c0 1.452.348 2.827.957 4.042l3.007-2.332z"
      />
      <path
        fill="#EA4335"
        d="M13.126 4.925l2.581-2.58C14.15.891 12.111 0 9.686 0a8.997 8.997 0 00-8.043 4.958L4.65 7.29c.707-2.127 2.691-3.71 5.036-3.71 1.32 0 2.507.454 3.44 1.345z"
      />
    </g>
  </svg>
);
